import {useCallback, useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetMyCompetition = () => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()

	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	const refetch = useCallback(() => {
		let url = `/${rolePath}/profile`
		fetchRequest('GET', url)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rolePath])

	useEffect(() => {
		refetch()
	}, [refetch])

	return [fetchResult, isLoading, refetch]
}

export default useGetMyCompetition
